import { Component, EventEmitter, OnInit, Output, ViewChild, inject } from '@angular/core';
import { Table } from 'primeng/table';
import { ConfirmationService } from 'primeng/api';
import { ToastService } from '../../../services/toast.service';
import { DescricaoPadraoService } from '../../../services/descricao-padrao.service';
import { AjustaTamanhoCampoHelper } from '../../../helpers/ajusta-tamanho-campo.helper';
import { DescricaoPadrao } from '../../../models/descricaoPadrao.model';
import { SeveridadeToast } from '../../../models/enums/severidade-toast.enum';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { Icones } from '../../../shared/variaveisDeRotas';
import { JwtHelper } from '../../../helpers/jwtDecode.helper';
import { retornaDescricao } from '../../../shared/mock/descricao';

@Component({
  selector: 'app-descricao-padrao-listar',
  templateUrl: './descricao-padrao-listar.component.html',
  styleUrls: ['./descricao-padrao-listar.component.scss'],
  providers: [ConfirmationService]
})
export class DescricaoPadraoListarComponent implements OnInit {
  @ViewChild('dt') dt: Table | undefined;
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  @Output() tituloDescricao = new EventEmitter<string>();
  @Output() textoDescricao = new EventEmitter<string>();
  @Output() mostrarDescricao = new EventEmitter<boolean>();

  descricaoPadrao: DescricaoPadrao[] = [];
  selectedDescricaoPadrao: DescricaoPadrao | null = null;
  detailsDialogVisible: boolean = false;
  userId: string;
  loading: boolean = false;

  constructor(
    private toastService: ToastService,
    private confirmationService: ConfirmationService,
    private descricaoPadraoService: DescricaoPadraoService,
    private ajustaTamanhoCampoHelper: AjustaTamanhoCampoHelper,
    private router: Router,
    private spinnerService: SpinnerService,
    private jwtHelper: JwtHelper,
  ) {
    this.userId = this.jwtHelper.getUserIdFromToken();

  }
  ngOnInit(): void {
    this.tituloChange.emit('Descrição Padrão');
    this.iconeChange.emit(Icones.listaAmarelo);
    this.tituloDescricao.emit(retornaDescricao('descricaoPadrao').titulo);
    this.textoDescricao.emit(retornaDescricao('descricaoPadrao').texto);
    this.mostrarDescricao.emit(true)

    this.spinnerService.show('Carregando descrições padrão...');
    this.loadDescricoesPadrao();
  }

  ngOnDestroy(): void {
    this.mostrarDescricao.emit(false);
  }

  loadDescricoesPadrao() {
    this.loading = true;
    this.descricaoPadraoService.getDescricaoPadrao(this.userId).subscribe({
      next: (data) => {
        this.descricaoPadrao = data;
        this.loading = false;
        this.spinnerService.hide();
      },
      error: (error) => {
        this.loading = false;
        this.retornarMensagemErro(error);
        this.spinnerService.hide();
      }
    });
  }

  openNew() {
    this.router.navigate(['/descricao-padrao/adicionar']);
  }

  editDescricaoPadrao(id: number) {
    this.router.navigate(['/descricao-padrao/editar', id]);
  }

  deleteDescricaoPadrao(descricaoPadrao: DescricaoPadrao) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja deletar esta descrição padrão?',
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.loading = true;
        this.spinnerService.show('Excluindo descrição padrão...');
        this.descricaoPadraoService
          .deleteDescricaoPadrao(descricaoPadrao.id)
          .subscribe({
            next: () => {
              this.loading = false;
              this.retornarMensagemSucesso('Descrição Padrão excluída com sucesso.');
              this.loadDescricoesPadrao();
              this.spinnerService.hide();
            },
            error: (e) => {
              this.loading = false;
              console.error('Erro ao excluir descrição:', e);
              this.retornarMensagemErro(e);
              this.spinnerService.hide();
            }
          });
      },
    });
  }

  applyFilterGlobal(value: string): void {
    if (this.dt) {
      this.dt.filterGlobal(value, 'contains');
    }
  }

  retornarMensagemSucesso(mensagem: string) {
    this.toastService.setMensagemToast(mensagem, SeveridadeToast.Success);
  }

  retornarMensagemErro(e: any) {
    let errorMessage = 'Erro desconhecido';

    if (typeof e.error === 'string') {
      errorMessage = e.error;
    } else if (Array.isArray(e.error)) {
      errorMessage = e.error.join(', ');
    } else if (e.error?.message) {
      errorMessage = e.error.message;
    } else {
      console.error('Erro ao processar erro:', e);
    }

    this.toastService.setMensagemToast(
      `Erro ao processar operação: ${errorMessage}`,
      SeveridadeToast.Error
    );
  }

  ajustaTamanhoCampo(valor: string): string {
    return this.ajustaTamanhoCampoHelper.ajustaTamanhoCampo(valor, 25);
  }

  ajustaTamanhoCampoDetalhes(valor: string): string {
    if (!valor) return '';
       return this.ajustaTamanhoCampoHelper.ajustaTamanhoCampo(valor, 60);
  }

  viewDetails(descricaoPadrao: DescricaoPadrao) {
    this.selectedDescricaoPadrao = descricaoPadrao;
    this.detailsDialogVisible = true;
  }
}
